var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclusionBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M24.757 17.942h-.03l-.319-.015-8.798-2.647c-.402-.078-.712-.4-.774-.805-.118-.395.016-.82.338-1.077l2.85-2.847V8.353l-.548-.437-.059.015c-.12.03-.245.047-.37.05-.53.01-1.042-.193-1.42-.566l-3.18-2.867c-.814-.77-.858-2.054-.097-2.878l.164-.164c.772-.807 2.048-.845 2.868-.088l3.188 2.88c.581.556.797 1.393.56 2.162l.674.548c.288.204.451.541.432.894v.539l1.395-1.338c.276-.296.694-.417 1.086-.314.353.124.635.397.77.746l2.347 8.985c.115.405-.017.84-.339 1.112-.192.202-.46.314-.738.31zm-.207-.655h.186c.114.005.225-.041.302-.125.145-.109.21-.294.163-.469L22.862 7.73c-.067-.15-.19-.266-.344-.323-.157-.028-.316.029-.42.148L19.58 9.971V7.877c.01-.137-.054-.27-.167-.349l-1.075-.872.103-.23c.255-.564.128-1.227-.317-1.657L14.94 1.897c-.56-.517-1.43-.49-1.957.06l-.162.162c-.51.56-.479 1.424.07 1.945l3.187 2.874c.245.255.587.394.94.384h.088c.052-.005.104-.014.154-.03.102-.029.207-.045.313-.048h.115l.991.793v2.784l-3.084 3.077c-.126.1-.176.266-.125.418.013.16.13.293.288.326l8.792 2.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.068 0.694H12.469V6.938H0.068z",
    transform: "translate(5.861 20.055)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.864 0.832H15.08V7.076H0.864z",
    transform: "translate(25.053 26.161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.262 0.096H12.741V6.337H0.262z",
    transform: "translate(18.074 33.14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.262 0.694H12.741V6.938H0.262z",
    transform: "translate(18.074 20.055)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.204 0.834H14.821000000000002V7.074999999999999H0.204z",
    transform: "translate(11.095 26.161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.068 0.834H5.438V7.074999999999999H0.068z",
    transform: "translate(5.861 26.161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.068 0.096H12.469V6.337H0.068z",
    transform: "translate(5.861 33.14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M18.549 27.208H5.71v-6.68H18.55v6.68zm-12.402-.436h11.965v-5.808H6.147v5.808zM40.35 33.456H25.698v-6.684h14.656l-.004 6.684zm-14.219-.436h13.783v-5.812h-13.78l-.003 5.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M31.033 39.696H18.117v-6.678h12.916v6.678zm-12.48-.436h12.043v-5.806H18.553v5.806zM31.033 27.208H18.117v-6.681h12.916v6.681zm-12.48-.436h12.043v-5.809H18.553v5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M26.134 33.454H11.081v-6.677h15.053v6.677zm-14.616-.436h14.18v-5.804h-14.18v5.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M11.518 33.454H5.71v-6.677h5.807v6.677zm-5.37-.436h4.933v-5.804H6.147v5.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.864 0.231H15.08V6.475H0.864z",
    transform: "translate(25.053 39.247)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.204 0.232H14.821000000000002V6.473H0.204z",
    transform: "translate(11.095 39.247)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C3",
    d: "M0.068 0.232H5.438V6.473H0.068z",
    transform: "translate(5.861 39.247)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M40.35 45.94H25.698v-6.68h14.656l-.004 6.68zm-14.219-.437h13.783v-5.807h-13.78l-.003 5.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M26.134 45.938H11.081v-6.677h15.053v6.677zm-14.616-.436h14.18v-5.804h-14.18v5.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M11.518 45.938H5.71v-6.677h5.807v6.677zm-5.37-.436h4.933v-5.804H6.147v5.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272727",
    d: "M18.549 39.696H5.71v-6.678H18.55v6.678zM6.147 39.26h11.965v-5.806H6.147v5.806zM2.66 22.222c-.156 0-.3-.083-.378-.219-.078-.135-.077-.302.002-.437 1.275-2.152 3.341-3.72 5.757-4.369.228-.062.465.068.533.295.069.226-.056.466-.28.54-2.203.588-4.089 2.014-5.255 3.973-.078.135-.222.217-.378.217zM1.308 20.598c-.156 0-.3-.084-.377-.22-.078-.134-.078-.3 0-.435 1.276-2.153 3.342-3.721 5.758-4.37.228-.063.465.068.533.295.069.226-.056.466-.28.54-2.203.589-4.089 2.014-5.255 3.973-.079.135-.223.218-.38.217z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusionBuild);
export default __webpack_public_path__ + "static/media/exclusion-build.aee36751d5dedbb4450c4125c89f2055.svg";
export { ForwardRef as ReactComponent };